/* eslint-disable */

import { useEffect } from "react";

const TawkChat = ({ user }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://embed.tawk.to/679bbc813a8427326077b375/1iis5gmsc";
    script.async = true;
    script.charset = "UTF-8";
    script.crossOrigin = "*";
    document.body.appendChild(script);

    script.onload = () => {
      if (window.Tawk_API) {
        console.log("Tawk.to API Loaded");

        // Login user with a generated hash
        window.Tawk_API.onLoad = function () {
          
            window.Tawk_API.setAttributes(
              {
                name: user.name,
                email: user.email,
                // hash: user.hash, // Secure hash from the backend
              },
              function (error) {
                if (error) console.log("Tawk API Error:", error);
              }
            );
          
        };
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, [user]);

  return null;
};

export default TawkChat;
